import 'assets/scss/index.scss'
import 'swiper/css'
import 'swiper/css/virtual'

import type { AppProps } from 'next/app'

import DefaultLayout from '@ui/layouts/default'
import MyHead from '@ui/components/next/MyHead'
import Error from './_error'
import { OrderProvider } from '@ui/contexts'
import type { NEXT_DATA } from 'next/dist/shared/lib/utils'

import { initSentry } from '@ui/analytics'
import { initializeClientState } from '@ui/helpers/initializeState'
import * as Sentry from '@sentry/node'

declare global {
  interface Window {
    __NEXT_DATA__: NEXT_DATA
    initMap?: () => void
    google?: any
  }
}

if (typeof window !== 'undefined') {
  initializeClientState()
}

initSentry()

const PAGE_LOAD_MARKER_KEY = 'cms_last_page'

if (typeof window !== 'undefined') {
  console.log('performance', performance)
  const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming
  const navType = navEntry?.type // 'navigate' | 'reload' | 'back_forward'
  const referrer = document.referrer
  const lastPage = localStorage.getItem(PAGE_LOAD_MARKER_KEY)

  let reloadReason: string | null = null

  if (navType === 'reload') {
    reloadReason = 'explicit_reload' // native app hoặc user bấm refresh
  } else if (navType === 'navigate' && referrer && !referrer.includes(window.location.hostname)) {
    reloadReason = 'external_redirect' // redirect back từ 3DS / payment gateway
  } else if (navType === 'navigate' && !referrer && lastPage) {
    reloadReason = 'webview_process_killed' // iOS kill WKWebProcess
  }

  console.log('reloadReason', reloadReason)
  if (reloadReason) {
    Sentry.captureMessage(`[PageLoad] unexpected reload: ${reloadReason}`, {
      level: Sentry.Severity.Warning,
      extra: { navType, referrer, lastPage, url: window.location.href }
    })
  }

  localStorage.setItem(PAGE_LOAD_MARKER_KEY, window.location.href)
}

function MyApp({ Component, pageProps }: AppProps) {
  if (pageProps?.statusCode >= 400) return <Error statusCode={pageProps.statusCode} />
  return (
    <>
      <MyHead />
      <DefaultLayout>
        <OrderProvider>
          <Component {...pageProps} />
        </OrderProvider>
      </DefaultLayout>
    </>
  )
}

export default MyApp
